
// CAMBIAR PREFIJO DEL PROYECTO
const prefixProject: string = "mxbudqtr"

enum ModalState { Closed, Opened };

interface ReferenceElement {
    selector?: string, target?: HTMLElement | undefined;
}

interface ModalInterface {
    state: ModalState;
    refModal: ReferenceElement;
    options: ModalOptions;

    playerModal?: any;
}

interface ModalOptions {
    delegationNode?: string;
    activators?: string;
    mainClass?: string;
    onOpen?(e: MouseEvent): void;
    onClose?(e: MouseEvent): void;

    iframeWrapper?: string;
}

export default class Modal implements ModalInterface {
    state: ModalState = ModalState.Closed;
    refModal: ReferenceElement;
    options: ModalOptions = { mainClass: `${prefixProject}-modal` };

    constructor(modalSelector: string, options?: ModalOptions) {
        this.refModal = { selector: modalSelector, target: document.querySelector(modalSelector) as HTMLElement };
        this.options = { ...this.options, ...options };
        this.init()
    }

    init(): void {
        this.setCloseModal()
        this.setOpenModal()
    }

    setOpenModal(): void {
        let { delegationNode, activators } = this.options
        if (delegationNode) {
            document.querySelector(delegationNode)?.addEventListener('click', (e: any) => {
                if (e.target.closest(activators)) {
                    let targetElm = e.target.closest(activators);
                    this.openModal(e, targetElm);
                }
            })
            return
        }
        else if (activators) {
            let nwActivators = document.querySelectorAll(activators);
            for (let i = 0; i < nwActivators.length; i++) {
                nwActivators[i].addEventListener('click', (e) => this.openModal(e, e.currentTarget))
            }
        }

    }

    setCloseModal(): void {
        let { target } = this.refModal;
        let { mainClass } = this.options;
        let closeClasses = [`${mainClass}`, `${mainClass}__close`, `${mainClass}__close-aditional`];
        target?.addEventListener('click', (e: any) => {
            let currentTarget = e.target as HTMLElement;
            closeClasses.forEach((className: string) => {
                if (currentTarget.classList.contains(className)) this.closeModal(e)
            })
        })
    }

    openModal(e: any, target: any): void {
        let { onOpen, mainClass } = this.options
        this.state = ModalState.Opened;

        this.toggleLoader('remove')
        this.refModal.target?.classList.remove(`${mainClass}--hide`)
        if (onOpen) onOpen(e)
    }

    closeModal(e: any): void {
        let { onClose, mainClass } = this.options
        this.state = ModalState.Closed;

        this.toggleLoader('add')
        this.refModal.target?.classList.add(`${mainClass}--hide`)
        if (onClose) onClose(e)
    }

    toggleLoader(state: 'add' | 'remove'): void {
        let { target } = this.refModal
        target?.querySelector(`.${prefixProject}-loader`)?.classList[state](`${prefixProject}-loader--hide`)
    }
}

export function simpleModal() {
    const modalGame = document.querySelector(".mxbudqtr-modal");
    const closeBtn = document.querySelector(".modal-close-icon");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        modalGame.classList.add("isClosed");
      });
    }
  }